import http from './httpService'
import config from '../../config.json'
import { getCurrentUserId } from './loginService'

const apiEndpoint = `${config.apiUrl}/CustomersPanel`

/**
 *
 * array of {Name:''}
 * @param {*} names
 * @returns
 */
export function getSettings(names) {
  return http.post(`${apiEndpoint}/Settings`, names)
}

export function getSearchTypeByName(name) {
  return http.get(`${apiEndpoint}/SearchTypes/`, name)
}

export function getOrderTypeByName(name) {
  return http.get(`${apiEndpoint}/OrderTypes/`, name)
}

export function getEnumsByName(name) {
  return http.get(`${apiEndpoint}/Enums/` + name)
}

export function getVersion(name) {
  return http.get(`${config.apiUrl}/Setting/CPVersion`)
}
